<template>
  <v-card>
    <v-card-title>
      Udalosti ({{ count }})

      <v-spacer/>

      <Create
          :icon="true"
          @init="init"
      />

      &nbsp;

      <v-btn
          :icon="true"
          :outlined="true"
          :loading="loading"
          :disabled="loading"
          color="default"
          @click="init"
      >
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col
            cols="12"
        >
          <v-expansion-panels
              v-model="expansionPanelsFilter"
              :multiple="true"
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                <span>
                  <v-icon
                      color="info"
                  >
                    mdi-filter
                  </v-icon>

                  Filtre
                </span>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row>
                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-text-field
                        v-model="params.Filters.startAtFrom"
                        :error-messages="errors.Filters && errors.Filters.startAtFrom"
                        :outlined="true"
                        :dense="true"
                        hide-details="auto"
                        label="Dátum začiatku od"
                        type="date"
                        :clearable="true"
                        @change="setFilter"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-text-field
                        v-model="params.Filters.startAtTo"
                        :error-messages="errors.Filters && errors.Filters.startAtTo"
                        :outlined="true"
                        :dense="true"
                        hide-details="auto"
                        label="Dátum začiatku do"
                        type="date"
                        :clearable="true"
                        @change="setFilter"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-text-field
                        v-model="params.Filters.title"
                        :error-messages="errors.Filters && errors.Filters.title"
                        :outlined="true"
                        :dense="true"
                        hide-details="auto"
                        label="Názov"
                        :clearable="true"
                        @change="setFilter"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <SuggestOrganizers
                        v-model="params.Filters.Organizer"
                        :error-messages="errors.Filters && errors.Filters.Organizer"
                        :outlined="true"
                        :dense="true"
                        hide-details="auto"
                        label="Organizátor"
                        :clearable="true"
                        :createButton="false"
                        @change="setFilter"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <SuggestCountries
                        v-model="params.Filters.Country"
                        :error-messages="errors.Filters && errors.Filters.Country"
                        :outlined="true"
                        :dense="true"
                        hide-details="auto"
                        label="Krajina"
                        :clearable="true"
                        :createButton="false"
                        @change="() => {
                          params.Filters.Region = null

                          setFilter()
                        }"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <SuggestRegions
                        v-model="params.Filters.Region"
                        :error-messages="errors.Filters && errors.Filters.Region"
                        :outlined="true"
                        :dense="true"
                        hide-details="auto"
                        label="Kraj"
                        :clearable="true"
                        :createButton="false"
                        :support="(regions) => regions.filter((Region) => (
                          params.Filters.Country
                            ? Region.Country.id === params.Filters.Country
                            : false
                        ))"
                        @change="setFilter"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-select
                        v-model="params.Filters.action"
                        :error-messages="errors.Filters && errors.Filters.action"
                        :outlined="true"
                        :dense="true"
                        hide-details="auto"
                        label="Akcia"
                        :items="$store.getters['register/getEventAction']"
                        no-data-text="Žiadne výsledky"
                        :clearable="true"
                        @change="setFilter"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-select
                        v-model="params.Filters.type"
                        :error-messages="errors.Filters && errors.Filters.type"
                        :outlined="true"
                        :dense="true"
                        hide-details="auto"
                        label="Typ"
                        :items="$store.getters['register/getEventType']"
                        no-data-text="Žiadne výsledky"
                        :clearable="true"
                        @change="setFilter"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row>
        <v-col
            cols="12"
        >
          <v-card>
            <v-card-text>
              <v-progress-linear
                  v-if="loading"
                  :indeterminate="true"
              />

              <v-simple-table>
                <template
                    v-slot:default
                >
                  <thead>
                    <tr>
                      <th>
                        <a
                            @click="setOrder($store.state.register.Event.Filter.order['startAt'].value)"
                        >
                          <template
                              v-if="params.order === $store.state.register.Event.Filter.order['startAt'].value"
                          >
                            <template
                                v-if="params.by === $store.state.register.Event.Filter.by['ASC'].value"
                            >
                              <v-icon>
                                mdi-chevron-up
                              </v-icon>
                            </template>

                            <template
                                v-else
                            >
                              <v-icon>
                                mdi-chevron-down
                              </v-icon>
                            </template>
                          </template>

                          Dátum a čas začiatku
                        </a>
                      </th>

                      <th>
                        Obrázok
                      </th>

                      <th
                          class="fixed"
                      >
                        Názov
                      </th>

                      <th>
                        Organizátor
                      </th>

                      <th>
                        Krajina
                      </th>

                      <th>
                        Kraj
                      </th>

                      <th>
                        Akcia
                      </th>

                      <th>
                        Typ
                      </th>

                      <th
                          class="text-right fixed"
                      />
                    </tr>
                  </thead>

                  <tbody>
                    <template
                        v-if="events.length > 0"
                    >
                      <tr
                          v-for="Event in events"
                          :key="Event.id"
                      >
                        <td>
                          {{ new Date(Event.startAt)|dateFormat('DD.MM.YYYY HH:mm') }}
                        </td>

                        <td>
                          <silent-box
                              v-if="Event.File"
                              :image="{
                                  src: loadLinkByPath('files/generate/image/original/' + Event.File.token)
                              }"
                          >
                            <template
                                v-slot:silentbox-item
                            >
                              <v-img
                                  :src="loadLinkByPath('files/generate/image/thumbnail/36/27/' + Event.File.token)"
                                  alt="Obrázok"
                                  max-width="36px"
                              />
                            </template>
                          </silent-box>

                          <template
                              v-else
                          >
                            <v-icon
                                color="error"
                            >
                              mdi-close
                            </v-icon>
                          </template>
                        </td>

                        <td
                            class="fixed"
                        >
                          <span
                              class="text-truncate"
                              style="max-width: 300px"
                          >
                            {{ Event.title }}
                          </span>
                        </td>

                        <td>
                          <template
                              v-if="Event.Organizer"
                          >
                            {{ Event.Organizer.billingName }}
                          </template>

                          <template
                              v-else
                          >
                            Nevyplnené
                          </template>
                        </td>

                        <td>
                          <template
                              v-if="Event.Region"
                          >
                            {{ Event.Region.Country.title }}
                          </template>

                          <template
                              v-else
                          >
                            Nevyplnené
                          </template>
                        </td>

                        <td>
                          <template
                              v-if="Event.Region"
                          >
                            {{ Event.Region.title }}
                          </template>

                          <template
                              v-else
                          >
                            Nevyplnené
                          </template>
                        </td>

                        <td>
                          {{ $store.state.register.Event.action[Event.action].text }}
                        </td>

                        <td>
                          {{ $store.state.register.Event.type[Event.type].text }}
                        </td>

                        <td
                            class="text-right fixed"
                        >
                          <v-btn
                              :icon="true"
                              :outlined="true"
                              color="primary"
                              :to="'/event/' + Event.id"
                          >
                            <v-icon>
                              mdi-magnify
                            </v-icon>
                          </v-btn>

                          &nbsp;

                          <Update
                              :icon="true"
                              :id="Event.id"
                              @init="init"
                          />

                          &nbsp;

                          <Delete
                              :icon="true"
                              :id="Event.id"
                              @init="init"
                          />
                        </td>
                      </tr>
                    </template>

                    <template
                        v-else
                    >
                      <tr>
                        <td
                            :colspan="10"
                            class="text-center"
                        >
                          Nenašli sa žiadne udalosti.
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row
          v-if="pages !== 0"
          align="center"
      >
        <v-col
            cols="4"
        >
          <a
              v-for="(limit, i) in $store.getters['register/getEventFilterLimit']"
              :key="i"
              @click="setLimit(limit.value)"
          >
            {{ limit.text }}
          </a>
        </v-col>

        <v-spacer/>

        <v-col
            cols="auto"
        >
          <v-btn
              :icon="true"
              :outlined="true"
              :loading="loading"
              :disabled="params.page === 1 || loading"
              color="primary"
              @click="previousPage"
          >
            <v-icon>
              mdi-chevron-left
            </v-icon>
          </v-btn>
        </v-col>

        <v-col
            cols="auto"
        >
          {{ params.page }} / {{ pages }}
        </v-col>

        <v-col
            cols="auto"
        >
          <v-btn
              :icon="true"
              :outlined="true"
              :loading="loading"
              :disabled="params.page === pages || loading"
              color="primary"
              @click="nextPage"
          >
            <v-icon>
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import Qs from 'qs'
  import QueryTypes from 'query-types'

  import Events from '@/services/events'

  import Create from '@/components/Events/Create'
  import Update from '@/components/Events/Update'
  import Delete from '@/components/Events/Delete'

  import SuggestOrganizers from '@/components/Organizers/Suggest'
  import SuggestCountries from '@/components/Countries/Suggest'
  import SuggestRegions from '@/components/Regions/Suggest'

  export default {
    name: 'Events',
    components: {
      Create,
      Update,
      Delete,
      SuggestOrganizers,
      SuggestCountries,
      SuggestRegions
    },
    data() {
      return {
        expansionPanelsFilter: [],
        loading: false,
        count: 0,
        pages: 1,
        events: [],
        params: {
          Filters: {
            startAtFrom: '',
            startAtTo: '',
            title: '',
            Organizer: '',
            Country: '',
            Region: '',
            action: '',
            type: ''
          },
          order: this.$store.state.register.Event.Filter.order['startAt'].value,
          by: this.$store.state.register.Event.Filter.by['DESC'].value,
          limit: this.$store.state.register.Event.Filter.limit[25].value,
          page: 1
        },
        errors: {}
      }
    },
    metaInfo() {
      return {
        title: 'Udalosti'
      }
    },
    beforeMount() {
      this.beforeInit()
    },
    mounted() {
      this.init()
    },
    methods: {
      beforeInit() {
        this.params = {
          ...this.params,
          ...Qs.parse(QueryTypes.parseObject(this.$route.query))
        }
      },
      init() {
        this.loadData()
      },
      setFilter() {
        this.params.page = 1

        this.init()
      },
      setOrder(order) {
        this.params.order = order

        switch (this.params.by) {
          case this.$store.state.register.Event.Filter.by['ASC'].value:
            this.params.by = this.$store.state.register.Event.Filter.by['DESC'].value

            break

          case this.$store.state.register.Event.Filter.by['DESC'].value:
            this.params.by = this.$store.state.register.Event.Filter.by['ASC'].value

            break
        }

        this.params.page = 1

        this.init()
      },
      setLimit(limit) {
        this.params.limit = limit

        this.params.page = 1

        this.init()
      },
      previousPage() {
        this.params.page -= 1

        window.scrollTo(0, 0)

        this.init()
      },
      nextPage() {
        this.params.page += 1

        window.scrollTo(0, 0)

        this.init()
      },
      setBreadcrumbs() {
        this.$store.dispatch('layout/setBreadcrumbs', {
          breadcrumbs: [
            {
              text: 'Udalosti',
              to: '/events'
            }
          ]
        })
      },
      loadData() {
        this.setBreadcrumbs()

        this.loading = true

        this.$router.replace('?' + Qs.stringify(this.params))

        Events
          .index({
            params: this.params
          })
          .then((response) => {
            this.count = response.data.data.count

            this.pages = response.data.data.pages

            this.events = response.data.data.events

            this.errors = {}
          })
          .catch((error) => {
            switch (error.response.status) {
              case 400:
                this.errors = error.response.data.errors

                break

              case 401:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      loadLinkByPath(path) {
        return process.env.VUE_APP_AXIOS_URL + path
      }
    }
  }
</script>
